import React, {useRef, useState, useEffect, useCallback} from 'react';

export const useWindows = ({ref}) => {
    let [size, setSize] = useState({
        width: 250,
        height: 150
    });
    let [ordering, setOrdering] = useState([]);
    const sizeRef = useRef(size);

    return {ordering, setOrdering, sizeRef, size, setSize};
};
